import { createSelector } from 'reselect';

export const getProductsData = (state) => state.products;
export const getProductsListingData = (state) => state.products.listing;

export const isLoadingProductsList = (state) => getProductsListingData(state).isLoading;

export const areProductsListLoaded = (state) => getProductsListingData(state).areProductsLoaded;

export const getProductsList = (state) => getProductsListingData(state).productsList;

export const getProductDetails = (state, { productId }) =>
    getProductsList(state).reduce((acc, cur) => ({
        ...acc, 
        [cur.id]: cur
    }), {})[productId];